import cgConstants from "../../config/cgConstants";
export default class CGQuoteApi {
  static getHeaders = () => {
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    return headers;
  };

  static getDestinations = async () => {
    const response = await fetch(`${cgConstants.CGApiUrl}/product/${cgConstants.CGProductId}/destination-countries`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static createQuote = async (data: any) => {
    const response = await fetch(`${cgConstants.CGApiUrl}/quote`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static createOrder = async (data: any) => {
    const response = await fetch(`${cgConstants.CGApiUrl}/orders/condensed/group`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: this.getHeaders(),
    });
    return response.json();
  };

  static getPaymentIntent = async (order_number: string) => {
    const response = await fetch(`${cgConstants.CGApiUrl}/orders/${order_number}/payment/intent`, {
      headers: this.getHeaders(),
    });
    return response.json();
  };
}
